import React from 'react';
import '../components-css/package.scss'
import DoneIcon from '@mui/icons-material/Done';

const Package = ({packageObj}) => {
    return (
        <div className={'package-wrapper'}>
            {/*{*/}
            {/*    packageObj.id === 2 && <span>Ամենապահանջված</span>*/}
            {/*}*/}
            <div className={`package-title title package-${packageObj.id}`}>{packageObj.packageTitle}</div>
            {
                packageObj.subTitle &&
                <div className={`package-title secondary-title t-${packageObj.id}`}>{packageObj.subTitle}</div>
            }
            <p className={'price'}>{packageObj.price} դրամ</p>
            <ul className={'features'}>
                {
                    packageObj.list.map((item, index) => {
                        return (
                            <li key={index} className={'list-item'}>
                                <DoneIcon sx={{color: "#BC3D96"}}/>
                                {item.important ? <p className={'li-item'} style={{color: "red"}}>{item.important}</p> : <p className={'li-item'}>{item}</p>}
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    );
};

export default Package;
